export default __webpack_public_path__ + "static/media/headerContract.1d52dbfe.png";